const items = [
  "Topi e Roditori",
  "Blatte e Scarafaggi",
  "Cimici dei Letti",
  "Calabroni e Vespe",
  "Tarme e Tarli del Legno",
  "Zanzare e Insetti Volanti",
  "Formiche",
  "HACCP Ristorazione",
];

export const Marquee = () => (
  <div className="overflow-hidden py-4 bg-moss text-amber-100 border-y border-mosslight">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0" aria-hidden={copy === 1}>
          {items.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="mx-6 font-mono text-xs tracking-[0.25em] uppercase whitespace-nowrap flex items-center gap-6"
            >
              {item}
              <span className="text-gold">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
